import apiUrl from '../../../constants';
import axios from 'axios';
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect
} from 'vue-search-select'
import Paginate from 'vuejs-paginate'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import CryptoJS from 'crypto-js';


export default {
  name: 'DisputeBulkUpload',
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading,
    Multiselect
  },
  data() {
    return {
      show: false,
      myStr: '',
      isLoading1: false,
      username:'',
      attachment:[],
      FileSelected: null,
      bulkDisputeCSVData:[],
      FailedRecords:'',
      FailedRecords:'',
      bulkDisputeCSVDataFlag:false,
      userFirstLastName : '',
      requiredColumns: ["ShippingID", "Comment"],
    }
  },
  mounted() {
    var userToken = window.localStorage.getItem('accessuserToken');
    this.myStr = userToken.replace(/"/g, '');
    this.username = window.localStorage.getItem('username');
    var userdetailEncrypt = window.localStorage.getItem('accessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userFirstLastName = userdetail.FirstName
  },
  computed: {

  },
  methods: {
    downloadSampleCsv() {
        const headers = this.requiredColumns;
        const csvContent = [headers.join(",")].join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "sample.csv";
        link.click();
    },
    onFileChange(e) {
      this.attachment = e.target.files[0];
      this.FileSelected = this.attachment;
      this.FileSelected = null;

    },
    uploadFile() {
            var form = new FormData();
            form.append('file', this.attachment);
            form.append('userName', this.username);
            form.append('username',this.userFirstLastName)
            var inputpayload = form;
            axios({
              method: 'post',
              url: `${apiUrl.api_url}uploadClientDebitCSV`,
              data: inputpayload,
              headers: {
                'Authorization': 'Bearer ' + this.myStr
              },
            }).then((result) => {
              if (result.data.ReturnCode !== 100) this.$alertify.error(result.data.ReturnMessage);
              if (result.data.ReturnCode === 100){
              this.bulkDisputeCSVData=result.data.FailedRecords
              this.bulkDisputeCSVDataFlag=true
              this.successData=result.data.Success
              this.FailedRecords=result.data.Failures
            }
            },
              (error) => {
                this.show = false;
                this.displaytable = false;
                console.error(error);
              });

            inputpayload = null;
            this.attachment = null;
            this.FileSelected = null;
    },

  }
}



// WEBPACK FOOTER //
// ./src/views/components/BulkforClientDebit/BulkforClientDebit.component.js